import { userGroupsEn } from './en'

export const userGroupsEnUs = userGroupsEn
